module.exports = new __parcel__URL__("lock_icon.d734f569.png").toString();